import React, { memo } from 'react';
import ReactMarkdown from 'react-markdown';

const markdownComponents = {
  a: ({ node, ...props }) => (
    <a {...props} target="_blank" rel="noopener noreferrer">
      {props.children}
    </a>
  )
};

const ThinkingDots = ({ inline = false }) => {
  return (
    <span className={`thinking-dots ${inline ? 'inline' : ''}`} aria-label="thinking" role="status">
      <span className="dot" />
      <span className="dot" />
      <span className="dot" />
    </span>
  );
};

const ControldocAiChatMessage = memo(({ message, isLastAssistant }) => {
  const isUser  = message.role === 'user';
  const isError = message.role === 'error';
  const isTool  = message.meta === 'tool';
  const isStreaming = !!message.streaming;

  const toolLabel  = String(message.content || message.tool_name || message.name || 'Ejecutando herramienta');
  const toolStatus = isTool ? (message.status || 'start') : null;
  const toolRunning = isTool && toolStatus === 'start';
  const toolError   = isTool && toolStatus === 'error';

  const content = () => {
    if (isError) {
      return (
        <div className="alert alert-danger mb-0" style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
          <ReactMarkdown components={markdownComponents}>
            {message.content}
          </ReactMarkdown>
        </div>
      );
    }

    if (isTool) {
      return (
        <div className={`tool-message ${toolRunning ? 'running' : toolError ? 'error' : 'finished'}`}>
          <span className="tool-icon">
            {toolRunning ? <span className="spinner" /> : toolError ? <span className="error-icon">✗</span> : '✓'}
          </span>
          <span className="tool-text">{toolLabel}</span>
          {toolRunning && <ThinkingDots inline />}
          {toolError && message.error && <span className="tool-error-msg"> — {String(message.error)}</span>}
        </div>
      );
    }

    if (isStreaming) {
      return <span className="markdown-stream-tail">{message.raw || ''}</span>;
    }

    return (
      <ReactMarkdown components={markdownComponents}>
        {message.content || ''}
      </ReactMarkdown>
    );
  }

  return (
    <div className={`chat-message ${isUser ? 'user-message' : 'assistant-message'} ${isTool ? 'tool' : ''}`}>
      <div className="message-content">
        {content()}
      </div>
    </div>
  );
});

export default ControldocAiChatMessage;
